import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bcc07b82")

_pushScopeId("data-v-bcc07b82")
const _hoisted_1 = { class: "preview" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("换一批")
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("成套")
const _hoisted_6 = { class: "margin-left-10" }
const _hoisted_7 = /*#__PURE__*/_createVNode("strong", null, "标签: ", -1)
const _hoisted_8 = {
  key: 0,
  class: "warning"
}
const _hoisted_9 = {
  key: 0,
  class: "flex flex-wrap padding-10"
}
const _hoisted_10 = { class: "image" }
const _hoisted_11 = {
  key: 0,
  class: "card-text"
}
const _hoisted_12 = { class: "selected flex" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("换一张")
const _hoisted_14 = { class: "tags" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_card = _resolveComponent("el-card")
  const _component_card_set_assembly_form = _resolveComponent("card-set-assembly-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_alternative_card_list = _resolveComponent("alternative-card-list")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "warning",
          class: "margin-left-10",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadPreview()))
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _hoisted_4,
        (_ctx.saveable)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              class: "margin-left-10",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveAssembly()))
            }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cardSetParts, (cardSetPart) => {
        return (_openBlock(), _createBlock("div", {
          class: "margin-top-10",
          key: cardSetPart.id
        }, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(cardSetPart.tagIds, (tagId) => {
              return (_openBlock(), _createBlock(_component_el_tag, { key: tagId }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.getTag(tagId).name), 1)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (cardSetPart.previewResult?.errorMessage)
              ? (_openBlock(), _createBlock("p", _hoisted_8, _toDisplayString(cardSetPart.previewResult?.errorMessage), 1))
              : _createCommentVNode("", true)
          ]),
          (cardSetPart.previewResult)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(cardSetPart.previewResult.cards, (card) => {
                  return (_openBlock(), _createBlock(_component_el_card, {
                    class: "card",
                    key: card.id
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_10, [
                        _createVNode(_component_el_image, {
                          class: "image",
                          src: card.cardUrl,
                          "preview-src-list": cardSetPart.previewResult.cards.map(c => c.cardUrl)
                        }, null, 8, ["src", "preview-src-list"]),
                        (cardSetPart.textVisible)
                          ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(card.cardText), 1))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_12, [
                          _createVNode(_component_el_button, {
                            onClick: ($event: any) => (_ctx.changeCard(cardSetPart, card)),
                            type: "warning",
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              _hoisted_13
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]),
                      _createVNode("div", _hoisted_14, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(card.cardTags, (cardTag) => {
                          return (_openBlock(), _createBlock(_component_el_tag, { key: cardTag }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.getTag(cardTag.tagId).name), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createVNode(_component_el_dialog, {
      title: "成套",
      modelValue: _ctx.cardSetAssemblyDialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.cardSetAssemblyDialogVisible = $event))
    }, {
      default: _withId(() => [
        _createVNode(_component_card_set_assembly_form, {
          "card-set-assembly": _ctx.currentSelectedCardSet,
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cardSetAssemblyDialogVisible = false)),
          onSuccess: _ctx.cardSetAssemblyCreated
        }, null, 8, ["card-set-assembly", "onSuccess"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "换卡",
      modelValue: _ctx.changeCardDialogVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeCardDialogVisible = $event))
    }, {
      default: _withId(() => [
        _createVNode(_component_alternative_card_list, {
          cardToChange: _ctx.cardToChange,
          cardSetPartToChange: _ctx.cardSetPartToChange,
          "exclude-card-ids": _ctx.cardSetParts.flatMap(p => p.previewResult.cards.map(c => c.id)).join(','),
          onSuccess: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeCardDialogVisible = false))
        }, null, 8, ["cardToChange", "cardSetPartToChange", "exclude-card-ids"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})